import { REACT_APP_API_ENDPOINT } from 'react-native-dotenv'

export const url = (path) => [REACT_APP_API_ENDPOINT.replace(/\/+$/, ''), path.replace(/^\/+/, '')].join('/')

let _TOKEN = "";

export const authMiddleware = store => next => action => {
    switch(action.type) {
        case 'auth/LOGIN': _TOKEN = action.data.jwt_token; break;
        case 'auth/LOGOUT': _TOKEN = ''; break;
    }

    return next(action);
}

export const request = async (method, path, data) => {
    const headers = { 'content-type': 'application/json' }
    if (_TOKEN) {
        headers.authorization = `Bearer ${_TOKEN}`
    }

    const resp = await fetch(url(path), {
        method,
        headers,
        body: data ? JSON.stringify(data) : null,
    });

    if (resp.status !== 200) {
        let msg = resp.statusText;

        try{ 
            const text = await resp.text()
            msg = text;
            const j = JSON.parse(text)
            msg = j.message || j.reason || j.error || msg;
        } catch(err) {}

        throw new Error(msg)
    }

    return {
        status: resp.status,
        data: await resp.json(),
    }
}

export const post = async (path, data) => {

    return await request('POST', path, data)
}

export const get = async (path) => {
    return await request('GET', path)
}
